__turbopack_context__.v({
  "Actions": "Navbar-module-scss-module__588nyW__Actions",
  "Cta": "Navbar-module-scss-module__588nyW__Cta",
  "Inner": "Navbar-module-scss-module__588nyW__Inner",
  "IsOpen": "Navbar-module-scss-module__588nyW__IsOpen",
  "Navbar": "Navbar-module-scss-module__588nyW__Navbar",
});
